export const getFinancialYear = (date: Date = new Date()): string => {
    const startYear = (date.getMonth() + 1) < 4 ? date.getFullYear() - 1 : date.getFullYear();
    const shortYear = (year: number) => String(year % 100).padStart(2, '0');
    return `${shortYear(startYear)}-${shortYear(startYear + 1)}`;
};

export const buildQuestionCode = (
    subjectCode: string,
    subjectName: string,
    refYear: string,
    refNo: number
): string => {
    const code = subjectCode || (subjectName ? subjectName.substring(0, 3) : '');
    return `${code}/${refYear}/${refNo}`;
};
